import type { FinanceTranslations } from './types'

/**
 * Arabic translations for Finance domain
 * Comprehensive translations covering all UI text
 */
export const arTranslations: FinanceTranslations = {
  // Page/Section level
  title: "المالية",
  subtitle: "إدارة العمليات المالية",
  overview: "نظرة عامة مالية",
  invoices: "الفواتير",
  invoicesDescription: "عرض وإدارة الفواتير",

  // Actions
  addFinance: "إضافة سجل مالي",
  editFinance: "تعديل السجل المالي",
  deleteFinance: "حذف السجل المالي",
  print: "طباعة",
  downloadReceipt: "تحميل الإيصال",

  // Search and filters
  searchPlaceholder: "البحث في المعاملات...",
  noItemsFound: "لم يتم العثور على سجلات مالية",
  noItemsDescription: "لم تقم بإضافة أي سجلات مالية بعد.",
  addFirst: "أضف سجلك المالي الأول",

  // Transactions
  transactions: "المعاملات",
  transactionsSubtitle: "عرض وإدارة جميع المعاملات",
  transactionHistory: "سجل المعاملات",
  transactionNumber: "رقم المعاملة",
  transactionDetails: "تفاصيل المعاملة",
  noTransactions: "لا توجد معاملات",
  noTransactionsDescription: "لا توجد معاملات تطابق التصفية الحالية.",
  totalInvoiced: "إجمالي الفواتير",
  totalPaid: "إجمالي المدفوع",
  outstanding: "المتبقي",
  loadingCharge: "رسوم التحميل",
  paymentReceived: "مدفوعات مستلمة",

  // Transaction types
  type: "النوع",
  payment: "دفعة",
  invoice: "فاتورة",
  credit: "إئتمان",
  debit: "مدين",
  completed: "مكتمل",
  failed: "فشل",
  processing: "قيد المعالجة",

  // Transaction details
  description: "الوصف",
  noDescription: "لا يوجد وصف",
  date: "التاريخ",
  amount: "المبلغ",
  reference: "المرجع",
  balanceAfter: "الرصيد بعد",
  actions: "الإجراءات",

  // Statement
  statement: "كشف الحساب",
  statementSubtitle: "كشف الحساب وتاريخ الرصيد",
  noStatement: "لا يوجد كشف حساب",
  noStatementDescription: "لا توجد بيانات كشف حساب للفترة المحددة.",
  openingBalance: "الرصيد الافتتاحي",
  closingBalance: "الرصيد الختامي",
  netChange: "صافي التغير",

  // Payments
  paymentsTitle: "المدفوعات",
  paymentsSubtitle: "إدارة مدفوعاتك وائتمانك",
  makePayment: "إجراء دفعة",
  paymentAmount: "مبلغ الدفعة",
  paymentMethod: "طريقة الدفع",
  selectMethod: "اختر طريقة الدفع",
  amountPlaceholder: "0.00",
  confirmPayment: "تأكيد الدفعة",
  recentPayments: "المدفوعات الأخيرة",
  noPayments: "لا توجد مدفوعات حديثة",
  noPaymentsDescription: "لا توجد مدفوعات تطابق عوامل التصفية الحالية.",
  searchPaymentsPlaceholder: "ابحث في المدفوعات...",
  allMethods: "كل الطرق",
  paymentDetails: "تفاصيل الدفعة",
  paymentNumber: "رقم الدفعة",
  sapReference: "مرجع SAP",
  origin: "المصدر",
  portalOrigin: "البوابة",
  notes: "ملاحظات",

  // Invoices
  invoicesTitle: "الفواتير",
  invoicesSubtitle: "عرض الفواتير من SAP",
  invoiceNumber: "رقم الفاتورة",
  issueDate: "التاريخ",
  netAmountLabel: "صافي المبلغ",
  vatAmountLabel: "مبلغ الضريبة",
  totalLabel: "الإجمالي",
  noInvoices: "لا توجد فواتير",
  noInvoicesDescription: "لا توجد فواتير تطابق عوامل التصفية الحالية.",
  searchInvoicesPlaceholder: "ابحث في الفواتير...",
  invoiceDetails: "تفاصيل الفاتورة",
  invoiceLines: "بنود الفاتورة",
  downloadPdf: "تحميل PDF",
  printInvoice: "طباعة الفاتورة",
  invoicePreviewTitle: "معاينة الفاتورة",
  invoicePreviewSubtitle: "راجع الفاتورة أدناه. الملف المشارك بصيغة PDF.",
  currency: "العملة",
  unitPrice: "سعر الوحدة",
  lineTotal: "المبلغ",
  quantity: "الكمية",
  material: "المادة",
  lineDescription: "الوصف",
  documentReference: "مرجع المستند",
  sapCustomerCode: "رمز العميل",
  salesOrganization: "منظمة المبيعات",
  documentType: "نوع المستند",
  amounts: "المبالغ",

  // Credit
  creditAccount: "حساب الائتمان",
  availableCredit: "الرصيد المتاح",
  creditLimit: "حد الائتمان",
  usedCredit: "الرصيد المستخدم",

  // Due payments
  dueIn30Days: "مستحق خلال 30 يوم",
  outstandingBalance: "الرصيد المستحق",

  // Payment methods
  viban: "VIBAN",
  bankTransfer: "تحويل بنكي",
  creditCard: "بطاقة ائتمان",
  vibanDesc: "الدفع عبر VIBAN",
  bankTransferDesc: "تحويل بنكي مباشر",
  creditCardDesc: "الدفع ببطاقة الائتمان",
  paymentMethods: "طرق الدفع",

  // VIBAN
  yourViban: "رقم VIBAN الخاص بك",
  copyViban: "نسخ VIBAN",
  copied: "تم النسخ!",
  vibanDescription: "حول الأموال إلى هذا الـ VIBAN لإضافة رصيد تلقائي لحسابك",

  // Stats
  receivable: "مستحق",
  payable: "مطلوب",
  pending: "قيد الانتظار",
  overdue: "متأخر",

  // Account status messages
  accountSuspended: "تم تعليق حسابك بسبب مدفوعات متأخرة. يرجى التواصل مع قسم المالية لحل المشكلة.",
  accountBlocked: "تم حظر حسابك. يرجى التواصل مع قسم المالية.",

  // Payment methods (used with dynamic keys)
  methods: {
    viban: "تحويل VIBAN",
    bank: "تحويل بنكي",
    card: "بطاقة ائتمان",
    cash: "نقداً",
    check: "شيك",
    bank_transfer: "تحويل بنكي",
    credit_card: "بطاقة ائتمان",
    sadad: "سداد",
  },

  // Form section
  form: {
    name: "اسم السجل",
    namePlaceholder: "أدخل اسم السجل",
    status: "الحالة",
    validation: {
      nameRequired: "اسم السجل مطلوب",
    }
  },

  // Status
  status: {
    active: "نشط",
    inactive: "غير نشط",
  },

  // Messages
  messages: {
    createSuccess: "تم إنشاء السجل المالي بنجاح",
    updateSuccess: "تم تحديث السجل المالي بنجاح",
    deleteSuccess: "تم حذف السجل المالي بنجاح",
    deleteConfirm: "هل أنت متأكد من حذف هذا السجل المالي؟",
  },

  // Table headers
  table: {
    name: "الاسم",
    status: "الحالة",
  },

  // Top-level convenience keys
  name: "الاسم",
  namePlaceholder: "أدخل اسم السجل",
  statusLabel: "الحالة",
  nameRequired: "اسم السجل مطلوب",
  active: "نشط",
  inactive: "غير نشط",
  createSuccess: "تم إنشاء السجل المالي بنجاح",
  updateSuccess: "تم تحديث السجل المالي بنجاح",
  deleteSuccess: "تم حذف السجل المالي بنجاح",
  deleteConfirm: "هل أنت متأكد من حذف هذا السجل المالي؟",

  // SAP Balances
  currentBalance: "الرصيد الحالي",
  availableContractBalance: "الرصيد المتاح",
  lastSynced: "آخر مزامنة",
  syncing: "جارٍ المزامنة...",

  // Retry SAP sync
  retrySapSync: "إعادة المزامنة مع SAP",
  syncingPayment: "جارٍ المزامنة...",
  retrySapSyncDescription: "إعادة إرسال هذه الدفعة إلى SAP",

  // Payment method top-level keys
  bank: "تحويل بنكي",
  card: "بطاقة ائتمان",
  cash: "نقداً",
  check: "شيك",
}
